import { Card, CardContent } from "@mui/material";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import {
  formattaDataCompatta,
  formatTimeRange,
} from "../../../utils/functions/date-utils";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { toast } from "react-toastify";
import { t } from "i18next";
import { useEffect, useState } from "react";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import {
  useDeleteBookingMutation,
  useGetBookingIdQuery,
} from "../../api/user/gestisciPraticheApi";
import { useNavigate } from "react-router-dom";
import { useGetAdminBookingIdQuery } from "../../api/admin/gestisciPraticheApi";
import { useSelector } from "react-redux";
import { ROLE } from "../../../utils/constants/profiles";

const Booking = ({
  spotId,
  practiceId,
  serviceCode,
  serviceId,
  userId = null,
  onClose,
}) => {
  const navigate = useNavigate();
  const role = useSelector((state) => state.app.role);

  const [openDialog, setOpenDialog] = useState(false);

  const [reservation, setReservation] = useState();

  const { data: dataBook, isLoading } = useGetBookingIdQuery(spotId, {
    skip: role !== ROLE.USER || !spotId,
  });

  const { data: dataBookAdmin, isLoading: loadingAdmin } =
    useGetAdminBookingIdQuery(
      {
        id: spotId,
        userId: userId,
      },
      { skip: role === ROLE.USER || !spotId }
    );

  const [deleteBooking] = useDeleteBookingMutation();

  useEffect(() => {
    if (dataBook) {
      setReservation(dataBook.Data);
    }

    if (dataBookAdmin) {
      setReservation(dataBookAdmin.Data);
    }
  }, [dataBook, dataBookAdmin]);

  const handleConfermDialog = () => {
    deleteBooking(spotId).then((res) => {
      if (res.data.Result !== 1) {
        toast.error(res.data.Exception || t("NotDeleteBooking"));
        return;
      }
      toast.success(t("DeleteBooking"));
      setOpenDialog(false);
      onClose();
    });
  };

  if (isLoading || loadingAdmin) {
    return <CoreSpinner />;
  }

  return (
    <div className="flex flex-col justify-center items-center">
      <h2>Prenotazione </h2>
      <Card className="rounded-xl shadow-xl w-[32rem] p-6">
        <CardContent>
          <div className="flex flex-col w-full items-center justify-between">
            <div className="w-full pt-5">
              <h3 className="m-0">Città </h3>
              <CoreInputField
                value={reservation?.descrizione_Provincia}
                className="w-full"
              />
            </div>

            <div className="w-full pt-5">
              <h3 className="m-0">Sede </h3>
              <CoreInputField
                value={reservation?.descrizione_Sede}
                className="w-full"
              />
            </div>
            {/* <div className="w-full pt-5">
              <h3 className="m-0">Sportello </h3>
              <CoreInputField
                value={reservation?.descrizione_Sportello}
                className="w-full"
              />
            </div> */}

            <div className="flex w-full space-x-4">
              <div className="w-full pt-5">
                <h3 className="m-0">Data</h3>
                <CoreInputField
                  value={formattaDataCompatta(reservation?.data)}
                  className="w-full"
                />
              </div>
              <div className="w-full pt-5">
                <h3 className="m-0">Ora</h3>
                <CoreInputField
                  value={formatTimeRange(
                    reservation?.ora_Inizio,
                    reservation?.ora_Fine
                  )}
                  className="w-full"
                />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      {role === ROLE.USER && (
        <div className="mt-20 w-full flex justify-around">
          <CoreButton
            className={"btn-round-outline "}
            variant="contained"
            testo={t("Edit")}
            onClick={() =>
              navigate(`/auth/user/${t("reservation")}`, {
                state: {
                  edit: true,
                  spotId: spotId,
                  practiceId: practiceId,
                  serviceCode: serviceCode,
                  serviceId: serviceId,
                },
              })
            }
          />
          <CoreButton
            className={"btn-round bg-red-600 border-red-600"}
            variant="contained"
            testo={t("Delete")}
            onClick={() => setOpenDialog(true)}
            disabled={!spotId}
          />
        </div>
      )}
      <CoreDialog
        open={openDialog}
        title={`Elimina Prenotazione`}
        content={`Sei sicuro di eliminare la prenotazione?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermDialog}
        closeDialog={() => setOpenDialog(false)}
      />
    </div>
  );
};

export default Booking;
